import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

const FormattedDate = ({ date }) => {
  return (
    <span className="FormattedDate">
      {date && format(date, 'MMMM d, yyyy')}
    </span>
  );
};

FormattedDate.propTypes = {
  date: PropTypes.object
};

export default FormattedDate;
